import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import ToggleTabGroup from '../../components/atoms/ToggleTabGroup';
import TextField from '../../components/molecules/TextField';
import { DEFAULT_SCHEDULE, SCHEDULE_FREQUENCIES, TRANSLATION_KEY } from '../constants';
import { getScheduleSummary } from '../utils';
import ScheduleDaysPicker from './ScheduleDaysPicker';
import css from './SchedulePicker.css';

const SCHEDULE_KEY = `${TRANSLATION_KEY}.SCHEDULE`;

const formatPresetTime = ({ hour, minute = 0 }) =>
    `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

const SchedulePicker = ({ preset, onChange, slackChannelName = null, translate }) => {
    const selectFrequency = frequency =>
        onChange({
            ...preset,
            frequency,
            days:
                frequency === SCHEDULE_FREQUENCIES.WEEKLY && !preset.days.length ? DEFAULT_SCHEDULE.days : preset.days,
        });

    const setTime = time => {
        const [hour, minute] = time.split(':').map(Number);
        if (Number.isInteger(hour) && Number.isInteger(minute)) onChange({ ...preset, hour, minute });
    };

    const frequencyOptions = Object.values(SCHEDULE_FREQUENCIES).map(option => ({
        option,
        label: translate(`${SCHEDULE_KEY}.${option.toUpperCase()}`),
    }));
    const summary = getScheduleSummary(preset, slackChannelName);

    return (
        <div className={css.schedule}>
            <div className={css.label}>
                <Translate id={`${SCHEDULE_KEY}.LABEL`} />
            </div>
            <div className={css.row}>
                <ToggleTabGroup
                    options={frequencyOptions}
                    selectedOption={preset.frequency}
                    onToggle={selectFrequency}
                />
                {preset.frequency !== SCHEDULE_FREQUENCIES.HOURLY && (
                    <TextField
                        type="time"
                        value={formatPresetTime(preset)}
                        containerClass={css.timeField}
                        inputClassName={css.timeInput}
                        onChange={setTime}
                    />
                )}
            </div>
            {preset.frequency === SCHEDULE_FREQUENCIES.WEEKLY && (
                <ScheduleDaysPicker days={preset.days} onChange={days => onChange({ ...preset, days })} />
            )}
            <div className={css.summary}>
                <Translate id={`${SCHEDULE_KEY}.${summary.key}`} data={summary.data} />
            </div>
        </div>
    );
};

SchedulePicker.propTypes = {
    preset: PropTypes.shape({
        frequency: PropTypes.oneOf(Object.values(SCHEDULE_FREQUENCIES)).isRequired,
        days: PropTypes.arrayOf(PropTypes.number).isRequired,
        hour: PropTypes.number.isRequired,
        minute: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    slackChannelName: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(SchedulePicker);
